var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "sc-grid",
    {
      ref: "gridLogsTrackingDetailEvent",
      attrs: {
        data: _vm.lote.eventsList,
        total: _vm.lote.eventsList.length,
        loading: _vm.loading,
        "has-style": false,
        "default-sort-column": "date",
        "default-sort-direction": "asc",
        "has-backend-pagination": true,
        "has-backend-sorting": false
      },
      on: { click: _vm.openEvent },
      scopedSlots: _vm._u([
        {
          key: "table-columns",
          fn: function(ref) {
            var props = ref.props
            return [
              _c(
                "sc-table-column",
                {
                  attrs: { label: "Date e hora", field: "date", width: "120" }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm._f("date")(props.row.date, "DD/MM/YYYY HH:mm:ss")
                      ) +
                      "\n    "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "sc-table-column",
                { attrs: { label: "Status", field: "status", width: "100" } },
                [_vm._v("\n      " + _vm._s(props.row.status) + "\n    ")]
              ),
              _vm._v(" "),
              _c(
                "sc-table-column",
                { attrs: { label: "Sub Status", field: "substatus" } },
                [_vm._v("\n      " + _vm._s(props.row.substatus) + "\n    ")]
              ),
              _vm._v(" "),
              _c(
                "sc-table-column",
                {
                  attrs: {
                    label: "Mensagem",
                    field: "message",
                    centered: false
                  }
                },
                [_vm._v("\n      " + _vm._s(props.row.message) + "\n    ")]
              ),
              _vm._v(" "),
              _c(
                "sc-table-column",
                {
                  attrs: { label: "Transportadora", field: "logistic_provider" }
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.getLogisticProviderName(
                          props.row.logistic_provider_id
                        )
                      ) +
                      "\n    "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "sc-table-column",
                {
                  attrs: {
                    label: "Nota fiscal",
                    field: "invoice_number",
                    width: "150"
                  }
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(props.row.invoice_number) + "\n    "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "sc-table-column",
                { attrs: { label: "Pedido", field: "shipment_order_number" } },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(props.row.shipment_order_number) +
                      "\n    "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "sc-table-column",
                {
                  attrs: {
                    label: "Cod. original",
                    field: "original_code",
                    width: "90"
                  }
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(props.row.original_code) + "\n    "
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "sc-table-column",
                {
                  attrs: {
                    label: "Cod. externo",
                    field: "external_code",
                    width: "90"
                  }
                },
                [
                  _vm._v(
                    "\n      " + _vm._s(props.row.external_code) + "\n    "
                  )
                ]
              )
            ]
          }
        }
      ])
    },
    [
      _c(
        "template",
        { attrs: { slot: "before-table" }, slot: "before-table" },
        [
          _c(
            "div",
            { staticClass: "buttons" },
            [
              _c("sc-button", {
                attrs: {
                  theme: "primary",
                  loading: _vm.loadingExporting,
                  text: "Exportar para o Excel"
                },
                on: {
                  click: function($event) {
                    _vm.exportLogsTrackingDetailEvent()
                  }
                }
              })
            ],
            1
          )
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-66295733", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66295733","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-analytic/features/logs/pages/tracking/pages/logs-tracking-lote-detail/tabs/tab-logs-tracking-lote-detail-event/TabLogsTrackingLoteDetailEvent.vue
// module id = null
// module chunks = 